import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import { auth } from "./auth.module";

const store = createStore({
  modules: {
    auth
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
});

export default store;
